import angular from 'angular'

import { noop } from 'lodash-es'

import envRaw from './env-raw'

angular
  .module('ggs.utils')
  .factory('DefineMethod', makeDefineProvider('debug', 'warn'))
  .factory('DefineHandler', makeDefineProvider('debug', 'error'))

function makeDefineProvider(debugLevel, errorLevel) {
  return function DefineProvider($log, $q) {
    'ngInject'

    return function Define(ownerTag) {
      const debug = envRaw.showsDefineDebug ? $log.force[debugLevel] : noop
      const error = $log[errorLevel]

      return define_helper

      function define_helper(handlerTag, action) {
        const initMsg = `[D] ${ownerTag}#${handlerTag} - init!`
        const doneMsg = `[D] ${ownerTag}#${handlerTag} - done!`
        const failMsg = `[D] ${ownerTag}#${handlerTag} - fail:`

        if (this !== undefined && this !== window) {
          this[handlerTag] = define_wrapper
          return this
        } else {
          return define_wrapper
        }

        function define_wrapper() {
          try {
            debug(initMsg)

            const res = action.apply(null, arguments)

            if (res && res.finally) {
              return res.then(() => {
                debug(doneMsg)
                return res
              }, (err) => {
                error(failMsg, err)
                return res
              })
            } else {
              debug(doneMsg)
              return $q.resolve(res)
            }
          } catch (err) {
            error(failMsg, err)
            return $q.reject(err)
          }
        }
      }
    }
  }
}
